export default __webpack_public_path__ + "static/media/section1-img3.ad29fcc7.png";